
export const handleDate = (inputDate, lang = "fr") => {
    const parsedDate = new Date(inputDate);

    const frenchMonthNames = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    const englishMonthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const arabicMonthNames = [
        "يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
        "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
    ];



    const day = parsedDate.getDate();
    const month = lang === "fr" ? frenchMonthNames[parsedDate.getMonth()] : lang === "en" ? englishMonthNames[parsedDate.getMonth()] : arabicMonthNames[parsedDate.getMonth()];
    const year = parsedDate.getFullYear();

    return  `${day} ${month} ${year}`;
}